import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { emotionalCards } from '../data/content';
export function EmotionalSection() {
  return <section className="w-full bg-ivory py-20 md:py-28" aria-labelledby="identificacion" data-id="element-46" data-mp="3ae8afkcmmzhf">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-47" data-mp="3eftkyz1ov1og">
        <SectionHeading eyebrow="Reconocerte" title={<span id="identificacion" data-id="element-49" data-mp="600gjikmtgnr">¿En qué momento dejaste de reconocerte?</span>} data-id="element-48" data-mp="3egmsw3cdvx86" />

        <div className="mx-auto mt-12 max-w-reading space-y-5 text-center font-sans text-[1rem] font-light leading-[1.9] text-warmgray" data-id="element-50" data-mp="5xxkagsvyral">
          <Reveal delay={0.05} data-id="element-51" data-mp="3t59cwicyhd5q">
            <p data-id="element-52" data-mp="3t47x60kzw2ho">Quizás no ocurrió de un día para otro. Fue poco a poco.</p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-53" data-mp="1x3rpa4i0obd">
            <p data-id="element-54" data-mp="20j76e233zdb">
              Empezaste a poner primero a todos. Tus responsabilidades crecieron. Tus sueños
              quedaron esperando.
            </p>
          </Reveal>
          <Reveal delay={0.15} data-id="element-55" data-mp="2mq8n6ueixr7l">
            <p data-id="element-56" data-mp="2ov81ydnmv3tn">Te acostumbraste a resolver, cumplir y seguir adelante.</p>
          </Reveal>
          <Reveal delay={0.2} data-id="element-57" data-mp="2ox1a5xdw9w3r">
            <p data-id="element-58" data-mp="2jwmy8496a20g">Pero en algún momento apareció una pregunta:</p>
          </Reveal>
          <Reveal delay={0.25} data-id="element-59" data-mp="2ytdzkj2epnsp">
            <p className="font-display text-[1.9rem] italic leading-snug text-ink sm:text-4xl" data-id="element-60" data-mp="2yufdqwepyqen">
              «¿Y yo dónde quedé?»
            </p>
          </Reveal>
        </div>

        <ul className="mt-16 grid gap-5 sm:grid-cols-2" data-id="element-61" data-mp="37tkbi0igifpr">
          {emotionalCards.map((card, i) => <Reveal key={card} delay={i * 0.08} data-id="element-62" data-mp="32v90vnkc816h" data-mpi={i}>
              <li className="h-full rounded-2xl border border-sand bg-shell/70 px-7 py-8 transition-colors duration-500 hover:border-goldsoft" data-id="element-63" data-mp="32ug33c3cwm0h">
                <span aria-hidden="true" className="font-display text-3xl leading-none text-goldsoft" data-id="element-64" data-mp="3cl2d8qsb0kbs">
                  “
                </span>
                <p className="mt-2 font-display text-xl font-light italic leading-relaxed text-ink" data-id="element-65" data-mp="3qld2jpdytquu">
                  {card}
                </p>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}